<div class="d-flex flex-wrap">
    <div *ngIf="!permission.label" class="permission-name col text-muted">{{ permission.name }}</div>
    <div *ngIf="permission.label" class="col">
        <div class="permission-label bb bl0 br0 bt0 border-dotted">{{ permission.label }}</div>
        <div class="permission-description text-muted">{{ permission.description }}</div>
    </div>
</div>
